/* eslint-disable max-len */
import { makeStyles } from '@mui/styles';
import Container from 'components/Container/Container';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/features-hero.s... Remove this comment to see the full error message
import BgSvg from 'components/Img/features-hero.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/manin-peace.svg... Remove this comment to see the full error message
import ManInPace from 'components/Img/manin-peace.svg';
import config from 'config';
import { memo } from 'react';
import { Helmet } from 'react-helmet-async';

import { Grid, Paper, Typography } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const useStyles = makeStyles(
  (theme) => ({
    '@keyframes peaceicon': {
      '0%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
      '50%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,17)',
      },
      '100%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
    },
    bg: {
      display: 'flex',
      color: '#fff',
      backgroundImage: `url(${BgSvg})`,
      fallbacks: [
        {
          backgroundImage: 'linear-gradient(-30deg, #00004d 0%, #5333ed 49%, #2cd4d9 100%)',
        },
      ],
      minHeight: 800,
      width: 'calc(100% + 2px)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    },
    container100: {
      height: '100%',
    },
    containerFeatures: {
      paddingTop: 50,
      zIndex: 99,
      position: 'relative',
      top: -100,
      backgroundColor: '#e1eaf8',
      paddingBottom: 72,
      '&:after': {
        height: 72,
        width: '100%',
        position: 'absolute',
        zIndex: -1,
        bottom: 0,
        content: '" "',
        display: 'block',
        // eslint-disable-next-line max-len
        backgroundImage:
          // eslint-disable-next-line quotes
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'><polygon fill='#fff' points='0,40 0,100 100,100 0,0' /></svg>\")",
        backgroundRepeat: 'no-repeat',
      },
    },
    paperFeatures: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(10),
    },
    typoWithIcon: {
      display: 'inline-flex',
    },
    iconsWithText: {
      fontSize: 28,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginRight: theme.spacing(3),
    },
    containerSecond: {
      position: 'relative',
      bottom: -120,
    },
    containerContentSecond: {
      textAlign: 'center',
    },
    peaceicon: {
      '& g > g > g > g:nth-child(2)': {
        animationName: '$peaceicon',
        animationDuration: '3s',
        animationIterationCount: 'infinite',
      },
    },
    paper: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
      height: 400,
    },
    paperNorrmal: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
    },
    iconBox: {
      fontSize: 70,
      marginBottom: 40,
    },
    containerOver: {
      position: 'relative',
      top: -220,
    },
    manInPeace: {
      paddingTop: 40,
      paddingBottom: 50,
      backgroundImage: `url(${ManInPace})`,
      backgroundRepeat: 'no-repeat',
      // backgroundSize: 'contain',
      backgroundPosition: 'right top',
    },
  }),
  { name: 'BringerTerms' }
);

const Home = memo(
  () => {
    const classes = useStyles();
    const title = 'Bringer Parcel Xpress';
    // eslint-disable-next-line
    const description =
      'Ship anywhere in the world with a click. Our online tools let you ship with confidence without downloading software';

    const { t } = useTranslation();

    const ldjson = {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: config.domain,
      name: config.app.title,
      alternateName: 'Bringer',
      image: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    const ldjsonOrg = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: config.app.title,
      legalName: 'Bringer CORP',
      email: `mailto:contact@${config.host}`,
      url: config.domain,
      logo: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <link rel="canonical" href={`${config.domain}/`} />
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
          <meta name="og:description" content={description} />
          <meta name="twitter:description" content={description} />
          <meta property="og:type" content="website" />
          <meta name="robots" content="index, follow" />
          <script type="application/ld+json">{JSON.stringify(ldjson)}</script>
          <script type="application/ld+json">{JSON.stringify(ldjsonOrg)}</script>
        </Helmet>
        <div className={classes.bg}>
          <Container>
            <Grid container alignItems="center" className={classes.container100}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h2" component="h1" color="inherit" gutterBottom>
                  {t('public.terms')}
                </Typography>
                <Typography variant="subtitle1" component="h3" color="inherit" gutterBottom>
                  {t('public.terms.1')}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className={classes.containerFeatures}>
          <Container>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Paper className={classes.paperNorrmal}>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.2')}</strong>
                  </Typography>
                  <p>{t('public.terms.3')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.4')}</strong>
                  </Typography>
                  <p>{t('public.terms.5')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.6')}</strong>
                  </Typography>
                  <p>{t('public.terms.7')}</p>
                  <p>{t('public.terms.8')}</p>
                  <ol type="a">
                    <li>
                      {t('public.terms.9')}
                      <ol>
                        <li>{t('public.terms.10')}</li>
                        <li>{t('public.terms.11')}</li>
                        <li>{t('public.terms.12')}</li>
                        <li>{t('public.terms.13')}</li>
                        <li>{t('public.terms.14')}</li>
                      </ol>
                    </li>
                    <li>
                      {t('public.terms.15')}
                      <ol>
                        <li>{t('public.terms.16')}</li>
                      </ol>
                    </li>
                  </ol>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.17')}</strong>
                  </Typography>
                  <p>{t('public.terms.18')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.19')}</strong>
                  </Typography>
                  <p>{t('public.terms.20')}</p>
                  <ol type="a">
                    <li>{t('public.terms.21')}</li>
                    <li>{t('public.terms.22')}</li>
                    <li>{t('public.terms.23')}</li>
                    <li>{t('public.terms.24')}</li>
                    <li>{t('public.terms.25')}</li>
                    <li>{t('public.terms.26')}</li>
                    <li>{t('public.terms.27')}</li>
                    <li>{t('public.terms.28')}</li>
                    <li>{t('public.terms.29')}</li>
                    <li>{t('public.terms.30')}</li>
                  </ol>
                  <p>{t('public.terms.31')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.32')}</strong>
                  </Typography>
                  <p>{t('public.terms.33')}</p>
                  <p>{t('public.terms.34')}</p>
                  <p>{t('public.terms.35')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.36')}</strong>
                  </Typography>
                  <p>{t('public.terms.37')}</p>
                  <p>{t('public.terms.38')}</p>
                  <p>{t('public.terms.39')}</p>
                  <p>{t('public.terms.40')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.41')}</strong>
                  </Typography>
                  <p>{t('public.terms.42')}</p>
                  <p>{t('public.terms.43')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.44')}</strong>
                  </Typography>
                  <p>{t('public.terms.45')}</p>
                  <ol type="a">
                    <li>
                      <strong>{t('public.terms.46.1')}</strong>: {t('public.terms.46.2')}
                    </li>
                    <li>
                      <strong>{t('public.terms.47.1')}</strong>: {t('public.terms.47.2')}
                    </li>
                  </ol>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.48')}</strong>
                  </Typography>
                  <p>{t('public.terms.49')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.50')}</strong>
                  </Typography>
                  <p>{t('public.terms.51')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.52')}</strong>
                  </Typography>
                  <p>{t('public.terms.53')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.54')}</strong>
                  </Typography>
                  <p>{t('public.terms.55')}</p>
                  <p>{t('public.terms.56')}</p>
                  <ul>
                    <li>Express Plus-USAU</li>
                    <li>Express Plus-USBR</li>
                    <li>Express Plus RX-USBR</li>
                    <li>Express Plus XP-USBR</li>
                    <li>Express Plus-USCA</li>
                    <li>Express Plus-USCO</li>
                    <li>Express Plus-USDE</li>
                    <li>Express Plus-USFR</li>
                    <li>Express Plus-USMX</li>
                    <li>Express Plus-USUK</li>
                    <li>Fulfillment</li>
                    <li>Packet Standard-USBR</li>
                    <li>Packet Express-USBR</li>
                    <li>Prime-USBR</li>
                    <li>Prime-USWORLD</li>
                    <li>Standard-USCA</li>
                    <li>Standard-USCO</li>
                    <li>Standard-USMX</li>
                    <li>Standard-USCL</li>
                    <li>Tracked Parcel-USWORLD</li>
                    <li>USPS Ground Advantage-USUS</li>
                  </ul>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.57')}</strong>
                  </Typography>
                  <p>{t('public.terms.58')}</p>
                  <ol type="a">
                    <li>{t('public.terms.59')}</li>
                    <li>{t('public.terms.60')}</li>
                    <li>{t('public.terms.61')}</li>
                  </ol>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.62')}</strong>
                  </Typography>
                  <p>{t('public.terms.63')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.64')}</strong>
                  </Typography>
                  <ol type="a">
                    <li>{t('public.terms.65')}</li>
                    <li>
                      {t('public.terms.66')} <br />
                      {t('public.terms.67')}
                      <ol>
                        <li>{t('public.terms.68')}</li>
                        <li>{t('public.terms.69')}</li>
                        <li>
                          {t('public.terms.70')}
                          <ul>
                            <li>{t('public.terms.71')}</li>
                            <li>{t('public.terms.72')}</li>
                            <li>{t('public.terms.73')}</li>
                            <li>{t('public.terms.74')}</li>
                          </ul>
                        </li>
                        <li>{t('public.terms.75')}</li>
                        <li>
                          {t('public.terms.73')}
                          <ul>
                            <li>{t('public.terms.77')}</li>
                            <li>{t('public.terms.78')}</li>
                          </ul>
                        </li>
                        <li>{t('public.terms.79')}</li>
                        <li>
                          {t('public.terms.80')}
                          <ul>
                            <li>{t('public.terms.81')}</li>
                          </ul>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <p>{t('public.terms.82')}</p>
                      <p>{t('public.terms.83')}</p>
                    </li>
                    <li>
                      <p>{t('public.terms.84')}</p>
                      <p>{t('public.terms.85')}</p>
                      <ol>
                        <li>{t('public.terms.86')}</li>
                        <li>
                          {t('public.terms.87')}
                          <ol>
                            <li>{t('public.terms.88')}</li>
                            <li>{t('public.terms.89')}</li>
                            <li>{t('public.terms.90')}</li>
                            <li>{t('public.terms.91')}</li>
                          </ol>
                        </li>
                        <li>{t('public.terms.92')}</li>
                      </ol>
                    </li>
                  </ol>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.93')}</strong>
                  </Typography>
                  <ol type="a">
                    <li>
                      <p>{t('public.terms.94')}</p>
                      <p>{t('public.terms.95')}</p>
                      <p>{t('public.terms.96')}</p>
                    </li>
                    <li>
                      <p>{t('public.terms.97')}</p>
                      <p>{t('public.terms.98')}</p>
                    </li>
                  </ol>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.99')}</strong>
                  </Typography>
                  <p>{t('public.terms.100')}</p>
                  <p>{t('public.terms.101')}</p>
                  <ul>
                    <li>{t('public.terms.102')}</li>
                    <li>{t('public.terms.103')}</li>
                    <li>{t('public.terms.104')}</li>
                  </ul>
                  <p>{t('public.terms.105')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.106')}</strong>
                  </Typography>
                  <p>{t('public.terms.107')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.108')}</strong>
                  </Typography>
                  <p>{t('public.terms.109')}</p>
                  <p>{t('public.terms.110')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.111')}</strong>
                  </Typography>
                  <ul>
                    <li>{t('public.terms.112')}</li>
                    <li>{t('public.terms.113')}</li>
                    <li>{t('public.terms.114')}</li>
                    <li>{t('public.terms.115')}</li>
                  </ul>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.116')}</strong>
                  </Typography>
                  <p>{t('public.terms.117')}</p>
                  <p>{t('public.terms.118')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.119')}</strong>
                  </Typography>
                  <p>{t('public.terms.120')}</p>
                  <p>{t('public.terms.121')}</p>
                  <p>{t('public.terms.122')}</p>
                  <ul>
                    <li>{t('public.terms.123')}</li>
                    <li>{t('public.terms.124')}</li>
                    <li>{t('public.terms.125')}</li>
                    <li>{t('public.terms.126')}</li>
                    <li>{t('public.terms.127')}</li>
                  </ul>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.128')}</strong>
                  </Typography>
                  <p>{t('public.terms.129')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.130')}</strong>
                  </Typography>
                  <p>{t('public.terms.131')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.132')}</strong>
                  </Typography>
                  <p>{t('public.terms.133')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.134')}</strong>
                  </Typography>
                  <p>{t('public.terms.135')}</p>
                  <p>{t('public.terms.136')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.137')}</strong>
                  </Typography>
                  <p>{t('public.terms.138')}</p>
                  <Typography variant="h4" gutterBottom>
                    <strong>{t('public.terms.139')}</strong>
                  </Typography>
                  <p>{t('public.terms.140')}</p>
                  <Grid container spacing={5}>
                    <Grid item xs={12} sm={5}>
                      <Typography variant="h4" gutterBottom>
                        <strong>{t('public.terms.141')}</strong>
                      </Typography>
                      <Typography gutterBottom paragraph>
                        {t('public.terms.142')}
                        <br />
                        Bringer Parcel Xpress
                        <br />
                        (A division of Bringer Corporation)
                        <br />
                        8351 NW 21st Street,
                        <br />
                        Doral, FL, 33122
                        <br />
                        {t('public.terms.143')}
                        <br />
                        Email: support@bringer.com
                        <br />
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Container>
          <br />
          <br />
          <br />
        </div>
        <br />
        <br />
      </>
    );
  },
  () => true
);

export default Home;
